<template>
  <div class="box-card">
    <v-btn v-if="isEdit && useTrigger" class="prof-pic grey--text text--darken-2" right icon @click="onEditFoto">
      <v-icon large>mdi-camera</v-icon>
    </v-btn>
    <template>
      <v-img :src="image" :aspect-ratio="aspectRatio" />
    </template>
    <slot name="render"></slot>
    <profil-picture
      v-if="isEdit"
      :uploadUrl="uploadUrl"
      :useBase64="useBase64"
      :trigger="'#edit-profpic'"
      @upload="upload"
      @uploaded="uploaded"
    />
  </div>
</template>

<script>
import ProfilPicture from '../popup/ProfilPicture';
export default {
  name: 'BasePhotoProfil',
  components: { ProfilPicture },
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
    aspectRatio: {
      type: Number,
      default: 4 / 6,
    },
    useBase64: {
      type: Boolean,
      default: false,
    },
    photo: {
      type: String,
      required: true,
    },
    photodef: {
      type: String,
      default: 'avatar.png',
    },
    uploadUrl: {
      type: String,
      default: '',
    },
    useTrigger: {
      type: Boolean,
      default: true,
    },
    useBtn: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      image: '',
    };
  },
  mounted() {
    this.checkImage(this.photo);
  },
  methods: {
    onEditFoto() {
      this.$confirm(
        `Anda aka diarahkan ke laman Personal PTK untuk melakukan perubahan foto profil.`,
        'Ubah Foto Profil',
        {
          lblConfirmButton: 'Lanjutkan',
          lblCancelButton: 'Batal',
        }
      ).then(() => {
        window.open('https://personal-ptk.simpkb.id/', '_blank');
      });
    },

    upload(data) {
      this.$emit('upload', data);
    },
    uploaded() {
      this.$success('Unggah Foto berhasil disimpan');
      this.$emit('reload');
    },
    checkImage(imageSrc) {
      let img = new Image();
      img.onload = () => {
        this.image = imageSrc;
      };
      img.onerror = () => {
        this.image = this.$imgUrl(this.photodef);
      };
      img.src = imageSrc;
    },
  },
  watch: {
    photo: 'checkImage',
  },
};
</script>
<style scoped>
.box-card {
  position: relative;
}
.prof-pic {
  position: absolute;
  z-index: 1;
  right: 3%;
  top: 3%;
}
</style>
